module.exports = __webpack_public_path__ + "static/fonts/OPPOSans-H.95af9d8.ttf";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/OPPOSans-H.ttf
// module id = S4Xd
// module chunks = 1